<script>
    /* import PymChild from './PymChild.svelte'; */
    let assets = './static';
</script>

<!-- <PymChild /> -->
<div class="root">
    <a
        class="brand"
        href="https://vglive.no/vm/kamper?utm_source=vgarticle&utm_content=world-cup-2022-top"
        target="_top"
    >
        <div class="vglive-logo-narrow">
            <img src="https://www.vg.no/vgc/frimand/gfx/icons/vglive.svg?x=2" />
        </div>
        <div class="vglive-logo-wide">
            <img src="https://static.vg.no/img/fotball-vm-2022/live2.svg" />
        </div>
        <div class="title">
            <div class="title-wide">Fotball-VM 2022</div>
            <div class="title-narrow">VM</div>
        </div></a
    >
    <div class="nav">
        <ul>
            <li>
                <a
                    href="https://vglive.no/vm/kamper?utm_source=vgarticle&utm_content=world-cup-2022-top"
                    target="_top"><img src="{assets}/icons/matches.svg" alt="Kamper" /> Kamper</a
                >
            </li>
            <li>
                <a
                    href="https://vglive.no/vm/siste/nyheter?utm_source=vgarticle&utm_content=world-cup-2022-top"
                    target="_top"><img src="{assets}/icons/latest.svg" alt="Siste" /> Siste</a
                >
            </li>
            <li class="oversikt">
                <a
                    href="https://vglive.no/vm/oversikt/grupper?utm_source=vgarticle&utm_content=world-cup-2022-top"
                    target="_top"
                    ><img src="{assets}/icons/overview.svg" alt="Oversikt" /> Oversikt</a
                >
            </li>
            <li>
                <a
                    href="https://www.vg.no/spesial/2022/vm-profeten/?utm_source=vgarticle&utm_content=world-cup-2022-top"
                    target="_top"
                    ><img src="{assets}/icons/profeten.svg" alt="Profeten" /> Profeten</a
                >
            </li>
            <li>
                <a
                    href="https://www.vg.no/spesial/2022/vm-tvillingen/?utm_source=vgarticle&utm_content=world-cup-2022-top"
                    target="_top"
                    ><img src="{assets}/icons/tvillingen.svg" alt="Tvillingen" />
                    <span class="wide">Finn din VM-tvilling <span class="new">NY!</span></span>
                    <span class="narrow">Tvillingen</span></a
                >
            </li>
        </ul>
    </div>
</div>

<style lang="scss">
    @font-face {
        font-family: 'Inter';
        font-weight: 100 900;
        font-style: normal;
        font-named-instance: Regular;
        font-display: swap;
        src: url('https://www.vg.no/vgc/font-spesial/Inter/Inter-roman.subset.ttf#iefix')
                format('embedded-opentype'),
            url('https://www.vg.no/vgc/font-spesial/Inter/Inter-roman.subset.woff2') format('woff2');
    }

    @font-face {
        font-family: 'Inter';
        font-weight: 100 900;
        font-style: italic;
        font-named-instance: Italic;
        font-display: swap;
        src: url('https://www.vg.no/vgc/font-spesial/Inter/Inter-italic.subset.ttf#iefix')
                format('embedded-opentype'),
            url('https://www.vg.no/vgc/font-spesial/Inter/Inter-italic.subset.woff2')
                format('woff2');
    }

    :global(html, body) {
        margin: 0;
        font-family: 'Inter';
        -webkit-font-smoothing: antialiased;
    }
    a {
        color: inherit;
        text-decoration: none;
    }
    .root {
        font-family: 'Inter';
        width: 100%;
        height: 50px;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;
        font-size: 16px;
        box-sizing: border-box;
    }
    .brand {
        display: flex;
        align-items: center;
        font-size: 0.8em;
        @media screen and (min-width: 375px) {
            font-size: 0.9em;
        }
        @media screen and (min-width: 768px) {
            font-size: 1em;
        }
    }
    .vglive-logo-narrow {
        border-radius: 4px;
        height: 14px;
        margin-right: 3px;
        padding: 2px;
        width: 14px;
        background-color: #000;
        box-sizing: border-box;
        align-items: center;
        display: flex;
        img {
            display: block;
            width: 100%;
        }
        @media screen and (min-width: 375px) {
            width: 16px;
            height: 16px;
            padding: 3px;
            margin-right: 4px;
        }
        @media screen and (min-width: 768px) {
            display: none;
        }
    }

    .wide {
        display: none;
        @media screen and (min-width: 840px) {
            display: flex;
        }
    }
    .narrow {
        @media screen and (min-width: 840px) {
            display: none;
        }
    }
    .vglive-logo-wide {
        border-radius: 4px;
        margin-right: 8px;
        padding: 0 8px;
        height: 28px;
        background-color: #000;
        box-sizing: border-box;
        align-items: center;
        display: none;
        img {
            display: block;
            width: 46px;
        }
        @media screen and (min-width: 768px) {
            display: flex;
        }
    }
    .title {
        font-weight: 800;
    }
    .title-narrow {
        @media screen and (min-width: 768px) {
            display: none;
        }
    }
    .title-wide {
        display: none;
        @media screen and (min-width: 768px) {
            display: block;
            font-size: 1.1em;
        }
    }

    .new {
        background-color: #dd0000;
        font-size: 10px;
        padding: 0px 4px;
        color: #fff;
        border-radius: 4px;
        font-weight: 700;
        margin-left: 5px;
        display: inline-flex;
        align-items: center;
    }
    ul {
        padding: 0;
        display: flex;
        li {
            list-style: none;
            a {
                display: flex;
                align-items: center;
                flex-wrap: nowrap;
                padding: 0 3px;
                font-size: 0.85em;
                font-weight: 600;
                @media screen and (min-width: 768px) {
                    font-size: 1em;
                    padding: 0 6px;
                }
            }
            &:first-child {
                a {
                    padding-left: 0;
                }
            }
            &:last-child {
                a {
                    padding-right: 0;
                    @media screen and (min-width: 768px) {
                        padding-right: 6px;
                    }
                }
            }
            &:last-child {
                a {
                    @media screen and (min-width: 768px) {
                        padding-right: 0;
                    }
                }
            }
        }
        img {
            height: 12px;
            width: 12px;
            opacity: 0.2;
            overflow: visible;
            margin-right: 3px;
            display: none;
            @media screen and (min-width: 360px) {
                display: block;
            }
            @media screen and (min-width: 375px) {
                height: 14px;
                width: 14px;
            }
            @media screen and (min-width: 768px) {
                height: 16px;
                width: 16px;
                margin-right: 6px;
            }
        }
    }

    .oversikt {
        display: none;
        @media screen and (min-width: 768px) {
            display: flex;
        }
    }
</style>
